import ReplyLeftIcon from '@atlaskit/icon-lab/core/reply-left';
import * as React from 'react';

export function SvgReplyLeft() {
  return <ReplyLeftIcon label="" testId="ads-refreshed-icon" />;
}
